import React from 'react';
import './css/footer.css';
import { useLanguage } from './contexts/LanguageContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram, faTiktok, faYoutube, faPatreon } from '@fortawesome/free-brands-svg-icons';
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';

const Footer = ({ onPrivacyPolicyClick }) => {
  const { t } = useLanguage();
  return (
    <div className="footer">
      <div className="footer-content">
        {/* Left Column - Legal Info */}
        <div className="footer-left">
          <h6 style={{fontFamily:"yourngo_title"}}>{t('footer.legalInformation')}</h6>
          <ul className="legal">
            <li>YourNGO NGO</li>
            <li><FontAwesomeIcon icon={faMapMarkerAlt} style={{marginRight: '10px'}} /> Lorem ipsum Str. 99<br /> 00000 Lorem City</li>
            <li><FontAwesomeIcon icon={faPhone} style={{marginRight: '10px'}} /> +00 0000 000000</li>
            <li><FontAwesomeIcon icon={faEnvelope} style={{marginRight: '10px'}} /> info@your-ngo.org</li>
          </ul>
        </div>

        {/* Right Column - Links + Social */}
        <div className="footer-right">
          <div className="footer-links">
            <h6 style={{fontFamily:"yourngo_title"}}>{t('footer.links')}</h6>
            <ul>
              <li><a href="#" onClick={(e) => { e.preventDefault(); onPrivacyPolicyClick(); }} style={{color: 'white', cursor: 'pointer'}}>{t('footer.privacyPolicy')}</a></li>
              <li><a href="/legal-constitution" style={{color: 'white'}}>{t('footer.legalConstitution')}</a></li>
              <li className="social-icons-footer">
                <a className="socialicon-footer" href="https://your-ngo.org" target="_blank" rel="noopener noreferrer" aria-label={t('footer.social.instagram')} title="Instagram">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
                <a className="socialicon-footer" href="https://tiktok.com/@yourngo" target="_blank" rel="noopener noreferrer" aria-label={t('footer.social.tiktok')} title="TikTok">
                  <FontAwesomeIcon icon={faTiktok} />
                </a>
                <a className="socialicon-footer" href="https://youtube.com/@yourngo2323" target="_blank" rel="noopener noreferrer" aria-label={t('footer.social.youtube')} title="YouTube">
                  <FontAwesomeIcon icon={faYoutube} />
                </a>
                <a className="socialicon-footer" href="https://patreon.com/YourNGO" target="_blank" rel="noopener noreferrer" aria-label={t('footer.social.patreon')} title="Patreon">
                  <FontAwesomeIcon icon={faPatreon} />
                </a>
              </li>
            </ul>
          </div>

        </div>
      </div>

      <div className="copyright">
        {t('footer.copyright')}
      </div>
    </div>
  );
};

export default Footer;
